import React from "react";
import PropTypes from "prop-types";
import { useStylesGeneral } from "../utils/mantine/stampTabContent/useStylesGeneral";
import { Box, Flex, Image, useMantineTheme } from "@mantine/core";

const Info = ({ textInfo, staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: GeneralClasses } = useStylesGeneral();
  return (
    <Flex
      align={theme.flex.align.center}
      className={GeneralClasses.stampFoundInfo}
    >
      <Box className={GeneralClasses.stampFoundInfoImg}>
        <Image
          src={`${staticBasePath}public/images/svg/rb-info-grey.svg`}
          alt="Info"
        />
      </Box>
      <Box className={`${GeneralClasses.stampFoundInfoText} stamp-info-text`}>
        {textInfo}
      </Box>
    </Flex>
  );
};
Info.propTypes = {
  textInfo: PropTypes.string.isRequired,
  staticBasePath: PropTypes.string.isRequired,
};
export default Info;
